// src/firebase.js

import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged, signInWithPopup, signOut, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyDBK2zTYDKhMx0xTYZzX6IPxXMTJlZuM6g',
  authDomain: 'conicle-design-system.firebaseapp.com',
  projectId: 'conicle-design-system',
  storageBucket: 'conicle-design-system.appspot.com',
  messagingSenderId: '218377693013',
  appId: '1:218377693013:web:707867d9247537469cf1dc'
}

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)

export { auth, onAuthStateChanged, signInWithPopup, signOut, GoogleAuthProvider }
